import ValidationIntl from "./Validation.i";

export default value => (value ? undefined : ValidationIntl.Require);
